import React from "react";
import NavBar from "../Admin/Dashboard/NavBar";
import Flow from "../../images/Flowchart(1).png";
import ReactProSidebar from "../Admin/Dashboard/ReactProSidebar";
import { useNavigate } from "react-router-dom";

import { ArrowBack } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

export default function FlowDiagram() {
  const navigate = useNavigate();

  const styles = {
    icon: {
      color: "#1976d2",
      fontSize: "31px",
    },
  };

  return (
    <div className="container">
      <NavBar />

      <main>
        <span>
          <Tooltip title="Back" placement="right">
            <IconButton
              onClick={() => navigate("/crawledInformation")}
              sx={styles.backButton}
              aria-label="back"
            >
              <ArrowBack sx={styles.icon} />
            </IconButton>
          </Tooltip>
        </span>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={Flow}
            alt="Information"
            style={{
              width: "auto", // Full viewport width
              height: "88vh", // Full viewport height
            }}
          />
        </div>
      </main>

      <ReactProSidebar />
    </div>
  );
}
